<template>






  <v-row justify="center">

<v-snackbar
      v-model="mensaje.snackbar"
      :timeout="mensaje.timeout"
      :color="mensaje.color"
      text
      top
      right
    >
      {{ mensaje.text }}

      <template v-slot:action="{ attrs }">
<v-btn
          :color="mensaje.colorBtn"
          text
          v-bind="attrs"
          @click="mensaje.snackbar = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>





    <v-dialog v-model="dialogeditarcategoria" persistent max-width="600">
      <v-card>
        <v-card-title class="text-h5">
          Editar Categoria
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="6">
                <v-text-field v-model="categoria.descripcion" label="Descripcion" required />
              </v-col>
                <v-col cols="12" sm="6">
                <v-text-field v-model="categoria.categoria_icon" label="Icono Categoria"/>
              </v-col> 

               <v-col cols="12" sm="6">
                <v-text-field v-model="categoria.categoria_link_photo" label="Link de la Foto"/>
              </v-col> 


              <v-col cols="12" sm="6">
                <v-text-field v-model="categoria.estado" label="Estado" />
              </v-col>

              <v-col cols="12" sm="6">
                  <v-select v-model="categoria.vendedor" :items="vendedores" item-text="nombre" item-value="id"
                  label="Seleccionar vendedor" return-object outlined dense>
                  
                  
                  </v-select>
</v-col>

             
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn     color="error" @click="closeDialog">Cancelar</v-btn>
          <v-btn   color="success" @click="guardarCambios">Registrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import categoriaService from "@/services/tienda/categoriaService.js";

import vendedorService from "@/services/tienda/vendedorService.js";


  import { 
   
  } from 'vuex'
export default {
  name: 'EditarCategoriaDialog', // importante para el warning
  data() {
    return {

        mensaje:{
          snackbar: false,
          text: '',
          color:'',
          timeout: 5000,
      },
      dialogeditarcategoria: false,

       vendedores: [],
      categoria: {
        id: null,
        descripcion:'',
        estado:'',
        categoria_icon:'',
       categoria_link_photo:'',
        vendedor:null,
       
      }
    }
  }, mounted() {




    this.listarVendedoresAdmin();


  },


  methods: {
    
     listarVendedoresAdmin() {
      vendedorService
        .listarVendedoresAdmin()
        .then((resposta) => {
          //    console.log(resposta.data);
          this.vendedores = resposta.data;
        })

    },
    
    /**
     * Abre el diálogo y carga datos del categoria
     */
    openDialog(categoria) {
      // clonar para no modificar directo el objeto padre
    //  this.categoria = { ...categoria }

    this.categoria = categoria ;
      this.dialogeditarcategoria = true
    },
    /**
     * Cierra el diálogo
     */
    closeDialog() {
      this.dialogeditarcategoria = false
    },
    /**
     * Guarda los cambios en el servidor
     */
    guardarCambios() {
      categoriaService.update(this.categoria)
        .then(respuesta => {
          // avisar al padre que actualice su lista
          this.$emit('actualizado')
          this.closeDialog()
        }).catch((errors) =>{

          let mensajeError = 'Ha ocurrido un error:\n';

  // Recorremos el array de errores del backend
  if (errors.response && errors.response.data && errors.response.data.errors) {
    errors.response.data.errors.forEach((err, index) => {
      mensajeError += `${index + 1}. ${err}\n`;
    });
  } else {
    mensajeError += 'Error desconocido';
  }

  // Asignamos al snackbar
  this.mensaje.text = mensajeError;
  this.mensaje.snackbar = true; // debe ser boolean
  this.mensaje.color = "error"; // fondo rojo
  this.mensaje.colorBtn = "red darken-2"; // color de botón contraste


  })
        
    }
  }
}
</script>
